import { connect } from 'react-redux';
// types
import { Dispatch } from 'types/dispatch';
import Root, { IRootStoreProps } from './root.component';
import { State } from 'widgets/free-content/root/root.reducers';

// actions
import { Actions as LoginActions } from 'modules/login';
import { Actions as LanguageActions } from 'modules/language-provider';

const { logOut } = LoginActions;
const { fetchLanguage } = LanguageActions;

const mapStateToProps = (state: State): IRootStoreProps => ({
    config: state.config,
    loginSession: state.login.loginSession,
    activeLanguageCode: state.language.activeLanguageCode,
    eventPlatforms: state.event?.data?.platforms
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    logOut: () => {
        dispatch(logOut());
    },
    fetchLanguage: (languageCode: string): void => {
        dispatch(fetchLanguage(languageCode));
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Root);
